import { http } from './http'
import { IUser } from './users'
import { IBenefits, ITranslation } from '../../common/models'

export type ReferralsType = 'ALL_USERS' | 'SINGLE_USER'

export interface Referral {
  id: string
  ticketName: string
  startDate: number
  endDate: number
  maxPerOrder: number
  maxReward: number
  addToBag: boolean
  published: boolean
  status: string
  referralDto: ReferralDto
  ticketCategoryId: string
  ticketId: string
  userProfileId: string
  buyerCashbackPercentage: number
  buyerCashbackValue: number
  buyerCashbackExpiryDate: string
  buyerCashbackAvailableDays: string
  referrerCashbackPercentage: string
  referrerCashbackValue: string
  referrerCashbackExpiryDate: string
  referrerCashbackAvailableDays: string
  referralDiscountPercentage: string
  referralDiscountValue: string
  unlimited: boolean
  userProfile?: IUser
}

export interface ReferralDto {
  firstName: string
  lastName: string
  email: string
  phone: string
  referralCode: string
}

export interface ReferralPayload {
  id?: string
  ticketId: string
  userProfileId?: string
  maxPerOrder: string
  buyerCashbackPercentage?: string
  buyerCashbackValue?: string
  buyerCashbackExpiryDate?: number
  buyerCashbackAvailableDays?: string
  referrerCashbackPercentage?: string
  referrerCashbackValue?: string
  referrerCashbackExpiryDate?: number
  referrerCashbackAvailableDays?: string
  referralDiscountPercentage?: string
  referralDiscountValue?: string
  maxReward?: string
  unlimited?: boolean
  startDate?: number
  endDate?: number
  addToBag?: boolean
  published?: boolean
}

export interface ReferralCreateResponse {
  referralConfigDetailsDto: ReferralConfigDetailsDto
  referralWarningDto: ReferralWarningDto
}

export interface ReferralConfigDetailsDto {
  id: string
  ticketId: string
  userProfileId: string
  maxPerOrder: number
  buyerCashbackPercentage: number
  buyerCashbackValue: number
  buyerCashbackExpiryDate: number
  buyerCashbackAvailableDays: number
  referrerCashbackPercentage: number
  referrerCashbackValue: number
  referrerCashbackExpiryDate: number
  referrerCashbackAvailableDays: number
  referralDiscountPercentage: number
  referralDiscountValue: number
  maxReward: number
  unlimited: boolean
  startDate: number
  endDate: number
  addToBag: boolean
  published: boolean
}

export interface ReferralWarningDto {
  userSummaryDto: UserSummaryDto
  ticketName: string
}

export interface UserSummaryDto {
  id: string
  firstName: string
  lastName: string
  phone: string
  email: string
  referralCode: string
}

export const getReferrals = (type?: ReferralsType) =>
  http.get<Referral[]>('/operations/referrals', {
    params: {
      referralType: type,
    },
  })

export const createReferral = (body: ReferralPayload) =>
  http.put<ReferralCreateResponse>('/operations/referrals', body)

export const deleteReferral = (id: string) =>
  http.delete<void>(`/operations/referrals/${id}`)

export const getReferral = (id: string) =>
  http.get<Referral>(`/operations/referrals/${id}`)

export const getShareReferralDescription = () =>
  http.get<ITranslation[]>(`/operations/referrals/benefits-description`)

export const createShareReferralDescription = (body: ITranslation[]) =>
  http.post<ITranslation[]>('/operations/referrals/benefits-description', body)

export const getShareReferralBenefits = () =>
  http.get<IBenefits[]>(`/operations/referrals/benefits-item`)

export const createShareReferralBenefits = (body: IBenefits) =>
  http.post<IBenefits>('/operations/referrals/benefits-item', body)

export const updateShareReferralBenefits = (body: IBenefits, id: string) =>
  http.put<IBenefits>(`/operations/referrals/benefits-item/${id}`, body)

export const deleteShareReferralBenefit = (id: string) =>
  http.delete(`/operations/referrals/benefits-item/${id}`)
